import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { DashboardLayout } from '../../components/DashboardLayout';
import { LayoutDashboard, Users, Shield, AlertTriangle, Eye, CheckCircle, XCircle, Clock, FileText, Search, Filter } from 'lucide-react';
import { MessageModal } from '../../components/modals/MessageModal';
import { ConfirmModal } from '../../components/modals/ConfirmModal';
export function AdvocacyModerationPage() {
  const [statusFilter, setStatusFilter] = useState('Pending Review');
  const [searchQuery, setSearchQuery] = useState('');
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState<any>(null);
  const [rejectReason, setRejectReason] = useState('');
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/admin'
  }, {
    label: 'User Management',
    icon: Users,
    path: '/admin/users'
  }, {
    label: 'Advocacy Moderation',
    icon: Shield,
    path: '/admin/advocacy-moderation',
    badge: '8'
  }, {
    label: 'Disputes',
    icon: AlertTriangle,
    path: '/admin/disputes'
  }];
  const posts = [{
    id: 1,
    title: 'No Water Connection After 3 Years',
    author: 'Rajesh Kumar',
    authorEmail: 'rajesh@example.com',
    project: 'Lake View Plots',
    developer: 'Lake Developers',
    location: 'Pune',
    category: 'Infrastructure',
    status: 'Pending Review',
    submittedDate: '2024-01-20 14:30',
    description: 'Despite taking possession 3 years ago, municipal water connection has not been provided. We are forced to rely on expensive tanker water. Multiple complaints to developer have gone unanswered.',
    evidence: ['water_bill.pdf', 'complaint_emails.pdf', 'site_photo.jpg'],
    impactLevel: 'high',
    verificationStatus: 'Verified Buyer'
  }, {
    id: 2,
    title: 'Missing Amenities as Promised',
    author: 'Priya Sharma',
    authorEmail: 'priya@example.com',
    project: 'Sunrise Heights',
    developer: 'XYZ Constructions',
    location: 'Bangalore',
    category: 'Infrastructure',
    status: 'Pending Review',
    submittedDate: '2024-01-20 12:15',
    description: 'Developer promised clubhouse, swimming pool, and landscaped gardens in brochure. None of these amenities have been delivered even after full payment and possession.',
    evidence: ['brochure.pdf', 'booking_receipt.pdf'],
    impactLevel: 'medium',
    verificationStatus: 'Verified Buyer'
  }, {
    id: 3,
    title: 'Unauthorized Construction Charges Demanded',
    author: 'Amit Patel',
    authorEmail: 'amit@example.com',
    project: 'Metro Residency',
    developer: 'Metro Builders',
    location: 'Gurgaon',
    category: 'Financial',
    status: 'Flagged',
    submittedDate: '2024-01-19 16:45',
    description: 'Developer demanding additional ₹5 lakhs for "construction charges" not mentioned in original agreement. Threatening to withhold possession if not paid.',
    evidence: ['agreement.pdf', 'demand_letter.pdf'],
    impactLevel: 'high',
    verificationStatus: 'Verified Buyer',
    flagReason: 'Potentially defamatory language - needs review'
  }];
  const filteredPosts = posts.filter(post => {
    const matchesStatus = statusFilter === 'All' || post.status === statusFilter;
    const matchesSearch = searchQuery === '' || post.title.toLowerCase().includes(searchQuery.toLowerCase()) || post.project.toLowerCase().includes(searchQuery.toLowerCase()) || post.author.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesStatus && matchesSearch;
  });
  const handleApprove = (post: any) => {
    setSelectedPost(post);
    setIsApproveModalOpen(true);
  };
  const handleReject = (post: any) => {
    setSelectedPost(post);
    setIsRejectModalOpen(true);
  };
  const confirmApprove = () => {
    setIsApproveModalOpen(false);
    setIsMessageModalOpen(true);
  };
  const confirmReject = () => {
    if (!rejectReason) {
      alert('Please provide a reason for rejection');
      return;
    }
    setIsRejectModalOpen(false);
    setRejectReason('');
    setIsMessageModalOpen(true);
  };
  return <DashboardLayout title="Admin Console" personaLabel="ADMIN" personaColor="bg-purple-100 text-purple-800 border-purple-200" navItems={navItems} userInitials="AD" data-id="element-1246">
      <div className="mb-8" data-id="element-1247">
        <h1 className="text-2xl font-bold mb-1" data-id="element-1248">Advocacy Moderation Queue</h1>
        <p className="text-gray-500 font-mono text-sm" data-id="element-1249">
          Review and moderate advocacy posts before publication
        </p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8" data-id="element-1250">
        <div className="bg-white border border-gray-300 p-6" data-id="element-1251">
          <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-1252">
            Pending Review
          </h3>
          <div className="text-3xl font-bold text-yellow-600" data-id="element-1253">
            {posts.filter(p => p.status === 'Pending Review').length}
          </div>
        </div>
        <div className="bg-white border border-gray-300 p-6" data-id="element-1254">
          <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-1255">
            Flagged
          </h3>
          <div className="text-3xl font-bold text-red-600" data-id="element-1256">
            {posts.filter(p => p.status === 'Flagged').length}
          </div>
        </div>
        <div className="bg-white border border-gray-300 p-6" data-id="element-1257">
          <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-1258">
            Approved Today
          </h3>
          <div className="text-3xl font-bold text-green-600" data-id="element-1259">12</div>
        </div>
        <div className="bg-white border border-gray-300 p-6" data-id="element-1260">
          <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-1261">
            Avg Response Time
          </h3>
          <div className="text-3xl font-bold" data-id="element-1262">4.2h</div>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white border border-gray-300 p-4 mb-6 flex flex-col md:flex-row gap-4" data-id="element-1263">
        <div className="relative flex-1" data-id="element-1264">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-1265" />
          <input type="text" placeholder="Search posts, projects, or authors..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500 text-sm" data-id="element-1266" />
        </div>
        <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="px-4 py-2 border border-gray-300 bg-white text-sm font-medium focus:outline-none focus:border-gray-500" data-id="element-1267">
          <option data-id="element-1268">Pending Review</option>
          <option data-id="element-1269">Flagged</option>
          <option data-id="element-1270">All</option>
        </select>
      </div>

      {/* Posts Queue */}
      <div className="space-y-6" data-id="element-1271">
        {filteredPosts.map(post => <div key={post.id} className="bg-white border border-gray-300 p-6" data-id="element-1272">
            <div className="flex items-start justify-between mb-4" data-id="element-1273">
              <div className="flex-1" data-id="element-1274">
                <div className="flex items-center gap-2 mb-3" data-id="element-1275">
                  <span className={`px-2 py-0.5 text-xs font-bold rounded border ${post.status === 'Flagged' ? 'bg-red-100 text-red-800 border-red-200' : 'bg-yellow-100 text-yellow-800 border-yellow-200'}`} data-id="element-1276">
                    {post.status.toUpperCase()}
                  </span>
                  <span className="px-2 py-0.5 bg-green-100 text-green-800 border border-green-200 text-xs font-bold rounded" data-id="element-1277">
                    {post.verificationStatus}
                  </span>
                  <span className="px-2 py-0.5 bg-gray-100 text-gray-700 text-xs font-bold" data-id="element-1278">
                    {post.category}
                  </span>
                  <span className={`px-2 py-0.5 text-xs font-bold rounded border ${post.impactLevel === 'high' ? 'bg-red-100 text-red-800 border-red-200' : 'bg-yellow-100 text-yellow-800 border-yellow-200'}`} data-id="element-1279">
                    {post.impactLevel.toUpperCase()} IMPACT
                  </span>
                </div>

                <h3 className="text-xl font-bold mb-2" data-id="element-1280">{post.title}</h3>

                <div className="grid grid-cols-2 gap-4 mb-4 text-sm text-gray-600" data-id="element-1281">
                  <div data-id="element-1282">
                    <span className="font-bold" data-id="element-1283">Author:</span> {post.author} (
                    {post.authorEmail})
                  </div>
                  <div data-id="element-1284">
                    <span className="font-bold" data-id="element-1285">Project:</span> {post.project}
                  </div>
                  <div data-id="element-1286">
                    <span className="font-bold" data-id="element-1287">Developer:</span>{' '}
                    {post.developer}
                  </div>
                  <div data-id="element-1288">
                    <span className="font-bold" data-id="element-1289">Location:</span> {post.location}
                  </div>
                </div>

                {post.flagReason && <div className="p-3 bg-red-50 border border-red-200 mb-4" data-id="element-1290">
                    <p className="text-xs font-bold text-red-900 mb-1" data-id="element-1291">
                      Flag Reason:
                    </p>
                    <p className="text-xs text-red-800" data-id="element-1292">{post.flagReason}</p>
                  </div>}

                <div className="p-4 bg-gray-50 border border-gray-200 mb-4" data-id="element-1293">
                  <p className="text-sm text-gray-700 leading-relaxed" data-id="element-1294">
                    {post.description}
                  </p>
                </div>

                <div className="flex items-center gap-4 text-sm text-gray-500 mb-4" data-id="element-1295">
                  <span className="flex items-center gap-1" data-id="element-1296">
                    <FileText className="w-4 h-4" data-id="element-1297" />
                    {post.evidence.length} evidence files
                  </span>
                  <span className="flex items-center gap-1" data-id="element-1298">
                    <Clock className="w-4 h-4" data-id="element-1299" />
                    Submitted: {post.submittedDate}
                  </span>
                </div>

                <div className="flex gap-2" data-id="element-1300">
                  {post.evidence.map((file, i) => <button key={i} className="px-3 py-1 bg-blue-50 text-blue-700 border border-blue-200 text-xs font-bold hover:bg-blue-100" data-id="element-1301">
                      View: {file}
                    </button>)}
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-3 pt-4 border-t border-gray-200" data-id="element-1302">
              <button onClick={() => handleReject(post)} className="flex items-center gap-2 px-4 py-2 border border-red-300 text-red-700 text-sm font-bold hover:bg-red-50" data-id="element-1303">
                <XCircle className="w-4 h-4" data-id="element-1304" />
                Reject
              </button>
              <button onClick={() => handleApprove(post)} className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white text-sm font-bold hover:bg-green-700" data-id="element-1305">
                <CheckCircle className="w-4 h-4" data-id="element-1306" />
                Approve & Publish
              </button>
            </div>
          </div>)}
      </div>

      {filteredPosts.length === 0 && <div className="bg-white border border-gray-300 p-12 text-center" data-id="element-1307">
          <Shield className="w-12 h-12 text-gray-300 mx-auto mb-4" data-id="element-1308" />
          <p className="text-gray-500 font-mono" data-id="element-1309">
            No posts in moderation queue
          </p>
        </div>}

      {/* Approve Modal */}
      <ConfirmModal isOpen={isApproveModalOpen} onClose={() => setIsApproveModalOpen(false)} onConfirm={confirmApprove} title="Approve Advocacy Post" message={`Are you sure you want to approve and publish "${selectedPost?.title}"? This will make it publicly visible.`} confirmText="Approve & Publish" type="success" data-id="element-1310" />

      {/* Reject Modal */}
      {isRejectModalOpen && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-1311">
          <div className="bg-white border border-gray-300 max-w-md w-full p-6" data-id="element-1312">
            <h3 className="font-bold text-lg mb-4" data-id="element-1313">Reject Advocacy Post</h3>
            <p className="text-sm text-gray-700 mb-4" data-id="element-1314">
              Provide a reason for rejection. This will be sent to the author.
            </p>
            <textarea value={rejectReason} onChange={e => setRejectReason(e.target.value)} placeholder="e.g., Insufficient evidence provided, defamatory language, duplicate post..." rows={4} className="w-full p-3 border border-gray-300 bg-gray-50 text-sm mb-4" data-id="element-1315" />
            <div className="flex justify-end gap-3" data-id="element-1316">
              <button onClick={() => {
            setIsRejectModalOpen(false);
            setRejectReason('');
          }} className="px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-1317">
                Cancel
              </button>
              <button onClick={confirmReject} className="px-4 py-2 bg-red-600 text-white text-sm font-bold hover:bg-red-700" data-id="element-1318">
                Reject Post
              </button>
            </div>
          </div>
        </div>}

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Action Completed" message="The advocacy post has been processed. The author has been notified via email." type="success" data-id="element-1319" />
    </DashboardLayout>;
}